import { render, staticRenderFns } from "./StartupsList.vue?vue&type=template&id=9be977ae&scoped=true&"
import script from "./StartupsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupsList.vue?vue&type=style&index=0&id=9be977ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be977ae",
  null
  
)

export default component.exports